import { render, staticRenderFns } from "./theoryManage.vue?vue&type=template&id=60ea2a3a&scoped=true"
import script from "./theoryManage.vue?vue&type=script&lang=js"
export * from "./theoryManage.vue?vue&type=script&lang=js"
import style0 from "./theoryManage.vue?vue&type=style&index=0&id=60ea2a3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ea2a3a",
  null
  
)

export default component.exports